import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { Checkbox } from '@mui/material';
const checkboxStyles = css `
  padding: 0;
`;
export const SelectionCheckbox = ({ ...rest }) => (_jsx(Checkbox, { size: "small", css: checkboxStyles, ...rest }));
